module.exports = __webpack_public_path__ + "static/media/chat.af589d2e.svg";